import DownloadIcon from '@mui/icons-material/Download';
import LoadingButton from '@mui/lab/LoadingButton';
import {Stack} from '@mui/material';
import {AxiosResponse} from 'axios';
import {FC, useContext, useState} from 'react';

import {DocumentService} from '../../../api/services/document.service';
import {ServiceRequestService} from '../../../api/services/serviceRequest.service';
import {EventBusContext} from '../../../providers/EventBus';
import {createObjectURL, resolveAndDownloadBlob} from '../../../shared/helpers/resolveAndDownloadBlob';

const UNIVERSAL_REPORT_ID = '1';

interface IUniversalReport {
  id: string;
  name: string;
  report: AxiosResponse<Blob>;
}

export const ReportUniversal: FC = () => {
  const [loading, setLoading] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [report, setReport] = useState<IUniversalReport | null>(null);
  const {bus} = useContext(EventBusContext);

  const openNewTab = (blob: Blob, fileName: string) => {
    const url = createObjectURL(blob);
    const id = url.split('/').pop();

    window.open(`/reports/universal/preview/${id}?data=${encodeURIComponent(fileName)}`, '_blank');
  };

  const fetchReport = async () => {
    const {
      data: {id: reportId, fileName},
    } = await ServiceRequestService.getUniversalReportByIDs(UNIVERSAL_REPORT_ID);

    if (!reportId) {
      throw new Error('Не удалось сформировать универсальный отчет.');
    }

    const resReport = await DocumentService.getContent(reportId);

    return {
      id: reportId,
      name: fileName || 'universal-report.xlsx',
      report: resReport,
    };
  };

  const downloadReport = async () => {
    if (report) {
      resolveAndDownloadBlob(report.report, report.name);
      return;
    }

    try {
      setLoading(true);
      const reportData = await fetchReport();
      setReport(reportData);
      resolveAndDownloadBlob(reportData.report, reportData.name);
    } catch (error) {
      bus?.emit('error', [error]);
    } finally {
      setLoading(false);
    }
  };

  const previewReport = async () => {
    if (report) {
      openNewTab(report.report.data, report.name);
      return;
    }

    try {
      setPreviewLoading(true);
      const reportData = await fetchReport();
      setReport(reportData);
      openNewTab(reportData.report.data, reportData.name);
    } catch (error) {
      bus?.emit('error', [error]);
    } finally {
      setPreviewLoading(false);
    }
  };

  return (
    <Stack sx={{px: 4, py: 4}} spacing={3}>
      <Stack direction="row" spacing={2} sx={{alignItems: 'flex-start'}}>
        <LoadingButton
          startIcon={<DownloadIcon />}
          variant="outlined"
          loading={loading}
          onClick={downloadReport}
          disabled={previewLoading}
          sx={{
            backgroundColor: 'white',
          }}
        >
          Скачать отчет
        </LoadingButton>
        <LoadingButton
          variant="outlined"
          loading={previewLoading}
          onClick={previewReport}
          disabled={loading}
          sx={{
            backgroundColor: 'white',
          }}
        >
          Просмотреть отчет
        </LoadingButton>
      </Stack>
    </Stack>
  );
};
